import { InlineEmailHelperWrapper } from "../InlineEmailHelperWrapper";
import { IEmailAttachmentCreation } from "../../../interfaces/IEmailAttachmentCreation";
import { IAttachmentInfo } from "../../../interfaces/IAttachmentInfo";

export class AddEmailer implements IEmailAttachmentCreation {
  constructor(private languageStrings: any, private isOrganization: boolean) {}
  async withAttachment(items: IAttachmentInfo[]) {
    await InlineEmailHelperWrapper.addEmailWithAttachments(items, this.languageStrings.UnableToAttachTryAgain);
  }

  async withShareableLink(items: IAttachmentInfo[]) {
    await InlineEmailHelperWrapper.addShareableLinks(items, this.languageStrings.UnableToAppendLinkTryAgain, this.isOrganization);
  }
}
